module.exports = __webpack_public_path__ + "static/img/2.8723f1e0.png";